import { useState, useEffect } from 'react';
import { useSocket } from '../../context/SocketContext';
import { useNavigate } from 'react-router-dom';
export default function IncomingMessageNotif() {
  const [notifs, setNotifs] = useState([]);
  const navigate = useNavigate();
  const globalSocketRef = useSocket();
  useEffect(() => {
    const onNewMessage = ({ fromUserId, fromPseudo, preview }) => {
      if (window.__mjOpenChats && window.__mjOpenChats.has(String(fromUserId))) return;
      const id = Date.now();
      setNotifs(prev => [...prev, { id, fromUserId, fromPseudo, preview }]);
      setTimeout(() => setNotifs(prev => prev.filter(n => n.id !== id)), 6000);
    };
    const interval = setInterval(() => {
      const socket = globalSocketRef?.current;
      if (!socket?.connected) return;
      socket.off('new-message', onNewMessage);
      socket.on('new-message', onNewMessage);
      clearInterval(interval);
    }, 300);
    return () => {
      clearInterval(interval);
      globalSocketRef?.current?.off('new-message', onNewMessage);
    };
  }, [globalSocketRef]);
  if (notifs.length === 0) return null;
  return (
    <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9998, display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-end' }}>
      {notifs.map(n => (
        <div key={n.id} style={{ background: '#1a0808', border: '1px solid #8b1a2a', borderRadius: 12, padding: '12px 16px', width: 280, boxShadow: '0 8px 32px rgba(0,0,0,0.4)', display: 'flex', gap: 10, alignItems: 'flex-start', animation: 'slideIn 0.3s ease' }}>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#8b1a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
            {(n.fromPseudo || 'U').slice(0, 2).toUpperCase()}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#e8a0a0', fontWeight: 700, letterSpacing: '0.08em', marginBottom: 2 }}>NOUVEAU MESSAGE</div>
            <div style={{ fontSize: 13, color: '#fff', fontWeight: 700, marginBottom: 2 }}>{n.fromPseudo}</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.preview}</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flexShrink: 0 }}>
            <button onClick={() => { setNotifs(prev => prev.filter(x => x.id !== n.id)); navigate('/profil?tab=messages'); }}
              style={{ padding: '4px 8px', borderRadius: 6, border: 'none', background: '#8b1a2a', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              Répondre
            </button>
            <button onClick={() => setNotifs(prev => prev.filter(x => x.id !== n.id))}
              style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid rgba(255,255,255,0.2)', background: 'transparent', color: 'rgba(255,255,255,0.5)', fontSize: 12, cursor: 'pointer' }}>
              Fermer
            </button>
          </div>
        </div>
      ))}
      <style>{`@keyframes slideIn { from { transform: translateX(120%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
    </div>
  );
}
